import React from 'react'


const ManageAssets = () => {
    return <div>Manage Assets</div>
}

export default ManageAssets